module.exports = __webpack_public_path__ + "img/logo-miodottore-turquoise-rgb.bc9db164.png";